(function() {

    'use strict';

    angular.module('app').controller('AccountingHistoricalBillingController', AccountingHistoricalBillingController);

    AccountingHistoricalBillingController.$inject = ['AccountingHistoricalBillingTableService'];

    function AccountingHistoricalBillingController(AccountingHistoricalBillingTableService) {

        const vm = this;
        vm.accountingHistoricalBillingTable = new AccountingHistoricalBillingTableService();
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/accounting/AccountingHistoricalBillingController.js